import regExp from 'utils/regExp';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const useFormSubmit = ({ action, required = [], ignore = [] }) => {
    const { t } = useTranslation();
    const [error, setError] = useState([]);
    const [selectedValue, setSelectedValue] = useState(null);
    const [submittedForm, setSubmittedForm] = useState(false);

    const handleSubmit = event => {
        event.preventDefault();
        // @todo: FormData does not work in IE
        const formData = new FormData(event.target);
        let data = {};
        const errors = [];

        // Extra validation for input fields that need more than html5 validation
        const validateInput = (name, value) => {
            // Check if reason is checked because html5 validation does not work on elements that are display none
            if ((name === 'reason' || name === 'state') && !selectedValue) {
                errors.push({
                    name,
                    message: t('Please select one'),
                });
            } else if (name === 'email') {
                !regExp.validation.correctEmail.test(value.toLowerCase()) &&
                    errors.push({
                        name,
                        message: t('Not a correct email, please check it'),
                    });
            }
        };

        // Loop through formData, for each name/data and add to the data object
        // @todo: for...of does not work in IE
        for (const [name, value] of formData) {
            validateInput(name, value);
            const ignoreData = name.indexOf(ignore) !== -1;
            data = !ignoreData ? { ...data, [name]: value } : { ...data };
        }

        // Double check if every required item exists in data, e.g. is a checkbox checked
        required.forEach(
            name =>
                Object.keys(data).indexOf(name) >= 0 ||
                errors.push({
                    name,
                    message: t('You have to check this'),
                })
        );

        if (errors.length < 1) {
            setError([]);

            typeof action === 'function' && action(data);

            // Hide form and show success message
            setSubmittedForm(true);
        } else {
            setError(errors);
        }
    };

    return {
        error,
        submittedForm,
        selectedValueArray: [selectedValue, setSelectedValue],
        handleSubmit,
    };
};

export default useFormSubmit;
